export { default as reacticoonConnect } from './reacticoonConnect'
export { default as StateContainer } from './StateContainer'
export * from './loadable'

// shortcuts to redux utilites
export { connect } from 'react-redux'
export { compose } from 'redux'
